import { render } from "./QuotesPage.vue?vue&type=template&id=4377e1ff&scoped=true"
import script from "./QuotesPage.vue?vue&type=script&lang=js"
export * from "./QuotesPage.vue?vue&type=script&lang=js"

import "./QuotesPage.vue?vue&type=style&index=0&id=4377e1ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4377e1ff"]])

export default __exports__